import { render } from "./LogoStoneRebrand.vue?vue&type=template&id=5afb1dfc&scoped=true"
import script from "./LogoStoneRebrand.vue?vue&type=script&lang=js"
export * from "./LogoStoneRebrand.vue?vue&type=script&lang=js"

import "./LogoStoneRebrand.vue?vue&type=style&index=0&id=5afb1dfc&scoped=true&lang=css"

import exportComponent from "/data/vstsagent/user/4153/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afb1dfc"],['__file',"src/components/emerald/atoms/LogoStoneRebrand.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5afb1dfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5afb1dfc', __exports__)) {
    console.log('reload')
    api.reload('5afb1dfc', __exports__)
  }
  
  module.hot.accept("./LogoStoneRebrand.vue?vue&type=template&id=5afb1dfc&scoped=true", () => {
    console.log('re-render')
    api.rerender('5afb1dfc', render)
  })

}


export default __exports__